import { gql } from '@/__generated__';
import { UserList_GetUsersQuery } from '@/__generated__/graphql';

export type UserList_User = UserList_GetUsersQuery['usersPagination']['items'][number];

const GET_USER_LIST = gql(`#graphql
  query UserList_GetUsers($input: UsersFilter, $pagination: PaginationInput, $sort: SortInput) {
    usersPagination(filter: $input, pagination: $pagination, sort: $sort) {
      items {
        id
        fullName
        email
        lastAccess
        phone
        twoFactorAuth
        shouldAuth
        status
        mainOrganization {
          organization {
            id
            name
            verifyAuthOrgs
          }
          role {
            id
            name
          }
        }
        additionalOrganizations {
          organization {
            id
            name
          }
          role {
            id
            name
          }
        }
        temporaryUser {
          activationToken
          activationTokenExpiration
          temporaryUserExpiration
          temporaryUserDurationDays
        }
        deletedAt
      }
      pageInfo {
        count
        limit
        offset
        pageNumber
        totalCount
      }
    }
  }

`);

export default GET_USER_LIST;
